import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../../../components/Header';
import FooterTwo from '../../../components/Footer/index';
import ScrollToTop from '../../../components/ScrollTop';
// import Loading from '../../../assets/images/icons/loading.gif';
import Banner from '../images/banners/governance_academic.webp';
const backendUrl = process.env.REACT_APP_DATABASEURL;
const Academiccouncils = () => {
     
    return (
        <>
            <Header
                parentMenu='university'
                menuCategoryEnable='enable'
            />
            <div class="react-wrapper background_height">
                <div class="react-wrapper-inner background_image">
                    <div className="react-breadcrumbs">
                        <div className="breadcrumbs-wrap">
                            <img className="desktop" src={Banner} alt="Breadcrumbs" />
                            <img className="mobile" src={Banner} alt="Breadcrumbs" />
                            <div className="breadcrumbs-inner">
                                <div className="container">
                                    <div className="breadcrumbs-text">
                                        <h1 className="breadcrumbs-title">AICTE Approvals</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="high_quality-section pt---60 pb---120">
                        <div class="container ">
                            <div class="row m-0">
                                <div class="col-md-12  col-sm-12 col-12 bg_color" style={{ backgroundColor: "#fff" }}>
                                   
                                    <div class="container">
                                          <center><span className="hedingname">AICTE Approvals</span></center> 
                                          <br/>
                                            <div className="table-responsive table-striped" style={{ width: "100%" }}>
                                                <table className="table responsive">
                                                    <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center",width: '4%' }}>S.No</th>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center", width: '45%' }}>Name</th>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center", width: '15%' }}>Action</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                             <tr>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>1</td>
                                                                <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>LOI 2024</td>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}><a href={`${backendUrl}approvals/LOI-2024.pdf`} target='_black' style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center"}} className="btn btn-primary">View</a></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>2</td>
                                                                <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>AICTE Approval 2024</td>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}><a href={`${backendUrl}approvals/2024-25.pdf`} target='_black' className="btn btn-primary" style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center"}}>View</a></td>
                                                            </tr>
                                                             <tr>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>3</td>
                                                                <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>AICTE Approval 2025</td>
                                                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}><a href={`${backendUrl}approvals/2025-26.pdf`} target='_black' className="btn btn-primary" style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center"}}>View</a></td>
                                                            </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ScrollToTop />
                </div>
            </div>
            <FooterTwo />
        </>
    );
}

export default Academiccouncils;